import React from 'react'
import { typeNames } from '../../../../ks/exam/configs'
import './Questions.styl'

const Questions = ({ question, index, displays, judge, inScored }) => {
    return (
        <div className="answer-sheet">
            {displays === true ? (
                <div className="analyze-type">
                    （{index}）{typeNames[question.type]}
                </div>
            ) : (
                ''
            )}
            <div className="question-content">
                <div className="row-1">题号</div>
                <div className="row-2">学生答案</div>
                <div className="row-3">答案</div>
                <div className="row-4">是否正确</div>
                <div className="row-5">分值</div>
                <div className="row-6">得分</div>
            </div>
            <div className="question-answer">
                <div className="row-1">{index}</div>
                <div className="row-2">{question.questionAnswer ? question.questionAnswer : '-'}</div>
                <div className="row-3">{question.answer}</div>
                <div className="row-4">{inScored ? judge : '-'}</div>
                <div className="row-5">{question.totalScore}</div>
                <div className="row-6">
                    {!inScored
                        ? '-'
                        : question.score
                        ? String(question.score).indexOf('.') + 1 > 0
                            ? question.score?.toFixed(1)
                            : question.score
                        : '0'}
                </div>
            </div>
        </div>
    )
}

export default Questions
